/**
 * @generated SignedSource<<3c813688bfb174c8fae0fe2b3d09ecf0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BeliefSystemsMultiSelectInput_query$data = {
  readonly beliefSystems: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
      readonly rowId: any;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "BeliefSystemsMultiSelectInput_query";
};
export type BeliefSystemsMultiSelectInput_query$key = {
  readonly " $data"?: BeliefSystemsMultiSelectInput_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BeliefSystemsMultiSelectInput_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BeliefSystemsMultiSelectInput_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SEQUENCE_ASC"
          ]
        }
      ],
      "concreteType": "BeliefSystemConnection",
      "kind": "LinkedField",
      "name": "beliefSystems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BeliefSystem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rowId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "beliefSystems(orderBy:[\"SEQUENCE_ASC\"])"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "79c2a4fef3b27d6d161c0b659fcd5507";

export default node;
